import { forwardRef, type SVGProps } from 'react';

export type ClipsProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const Clips = forwardRef<SVGSVGElement, ClipsProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="currentColor" viewBox="0 0 32 32">
    <path
      d="M27.17 23.82H4.63v-16h22.54zM10 7.84V23M21.93 7.84V23m-17.3-9.84h5m-5 5.33h5m12.56-5.33h5m-5 5.33h5"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
));
Clips.displayName = 'Clips';
